import type { TFieldConfig } from '../types'

export const warehousemanFields: TFieldConfig[] = [
  {
    name: 'warehouseman.full_name',
    labelKey: 'forms.warehouseman.full_name-title',
    placeholderKey: 'forms.warehouseman.full_name',
    model: 'full_name',
    component: 'Input',
    type: 'text',
  },
  {
    name: 'warehouseman.short_name',
    labelKey: 'forms.warehouseman.short_name-title',
    placeholderKey: 'forms.warehouseman.short_name',
    model: 'short_name',
    type: 'text',
  },
  {
    name: 'warehouseman.ceo_name',
    labelKey: 'forms.warehouseman.ceo_name-title',
    placeholderKey: 'forms.warehouseman.ceo_name',
    model: 'ceo_name',
    type: 'text',
  },
  {
    name: 'warehouseman.ceo_position',
    labelKey: 'forms.warehouseman.ceo_position-title',
    placeholderKey: 'forms.warehouseman.ceo_position',
    model: 'ceo_position',
    type: 'text',
  },
  {
    name: 'warehouseman.founded_on_basis',
    labelKey: 'forms.warehouseman.founded_on_basis-title',
    placeholderKey: 'forms.warehouseman.founded_on_basis',
    model: 'founded_on_basis',
    type: 'text',
  },
  {
    name: 'warehouseman.inn',
    labelKey: 'forms.warehouseman.inn-title',
    placeholderKey: 'forms.warehouseman.inn',
    model: 'inn',
    type: 'text',
  },
  {
    name: 'warehouseman.kpp',
    labelKey: 'forms.warehouseman.kpp-title',
    placeholderKey: 'forms.warehouseman.kpp',
    model: 'kpp',
    type: 'text',
  },
  {
    name: 'warehouseman.ogrn',
    labelKey: 'forms.warehouseman.ogrn-title',
    placeholderKey: 'forms.warehouseman.ogrn',
    model: 'ogrn',
    type: 'text',
  },
  {
    name: 'warehouseman.ogrn_date',
    labelKey: 'forms.warehouseman.ogrn_date-title',
    placeholderKey: 'forms.warehouseman.ogrn_date',
    model: 'ogrn_date',
    component: 'DatePicker',
    type: 'text',
  },
  {
    name: 'warehouseman.tax_authority',
    labelKey: 'forms.warehouseman.tax_authority-title',
    placeholderKey: 'forms.warehouseman.tax_authority',
    model: 'tax_authority',
    type: 'text',
  },
  {
    name: 'warehouseman.bank_bik',
    labelKey: 'forms.warehouseman.bank_bik-title',
    placeholderKey: 'forms.warehouseman.bank_bik',
    model: 'bank_bik',
    type: 'text',
  },
  {
    name: 'warehouseman.bank_name',
    labelKey: 'forms.warehouseman.bank_name-title',
    placeholderKey: 'forms.warehouseman.bank_name',
    model: 'bank_name',
    type: 'text',
  },
  {
    name: 'warehouseman.bank_corr_account',
    labelKey: 'forms.warehouseman.bank_corr_account-title',
    placeholderKey: 'forms.warehouseman.bank_corr_account',
    model: 'bank_corr_account',
    type: 'text',
  },
  {
    name: 'warehouseman.bank_account',
    labelKey: 'forms.warehouseman.bank_account-title',
    placeholderKey: 'forms.warehouseman.bank_account',
    model: 'bank_account',
    type: 'string',
  },
  {
    name: 'warehouseman.legal_address',
    labelKey: 'forms.warehouseman.legal_address-title',
    placeholderKey: 'forms.warehouseman.legal_address',
    model: 'legal_address',
    type: 'text',
  },
  {
    name: 'warehouseman.contact_person_name',
    labelKey: 'forms.warehouseman.contact_person_name-title',
    placeholderKey: 'forms.warehouseman.contact_person_name',
    model: 'contact_person_name',
    type: 'text',
  },
  {
    name: 'warehouseman.contact_person_phone',
    labelKey: 'forms.warehouseman.contact_person_phone-title',
    placeholderKey: 'forms.warehouseman.contact_person_phone',
    model: 'contact_person_phone',
    component: 'PhoneNumberInput',
    countryFormats: true,
  },
]
